export default {
    MIN_PLAYER: 1,
    MAX_PLAYER: 8
} as const
